import { Slideshow } from "./handler";

jQuery(window).on("elementor/frontend/init", () => {
  elementorFrontend.hooks.addAction(
    "frontend/element_ready/wfg-slideshow.default",
    ($element) => {
      elementorFrontend.elementsHandler.addHandler(Slideshow, {
        $element,
      });
    },
  );
});
